import { normalizeLanguageCode } from "@/lib/languages";

export const INTERNAL_POLICY_KEY = "internal_schedule_gdpr_notice";
export const INTERNAL_POLICY_VERSION = "2026-02-27";
export const INTERNAL_POLICY_EFFECTIVE_DATE = "2026-02-27";

export const INTERNAL_POLICY_LOCALES = ["hu", "en", "de"] as const;
export type InternalPolicyLocale = (typeof INTERNAL_POLICY_LOCALES)[number];

export const resolveInternalPolicyLocale = (value: string | null | undefined): InternalPolicyLocale => {
  const normalized = normalizeLanguageCode(value);
  if (normalized === "hu" || normalized === "en" || normalized === "de") {
    return normalized;
  }
  return "hu";
};
